import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../styles/Dashboard.css';

const Dashboard = ({ onLogout }) => {
  const navigate = useNavigate();
  return (
    <div className="dashboard-layout">
      <aside className="sidebar">
        <div className="sidebar-logo">
          <img src="/logo.png" alt="Pricol Logo" />
        </div>
        <nav className="sidebar-nav">
          <Link to="/dashboard" className="sidebar-link">Dashboard</Link>
          {/* <Link to="/users" className="sidebar-link">Users</Link> */}
          <Link to="/employees" className="sidebar-link">Employees</Link>
        </nav>
        <button className="sidebar-logout" onClick={() => onLogout(navigate)}>Logout</button>
      </aside>
      <main className="dashboard-main">
        <h1>Welcome to vCard Manager</h1>
        <div className="dashboard-cards">
          {/* <div className="dashboard-card">
            <h3>Users</h3>
            <p>Manage system users</p>
            <Link to="/users">View Users</Link>
          </div> */}
          <div className="dashboard-card">
            <h3>Employees</h3>
            <p>Manage employee profiles and vCards</p>
            <Link to="/employees">View Employees</Link>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Dashboard;